// extracted by mini-css-extract-plugin
module.exports = {"Tag":"Tag_Tag__UQ0FX","isGray":"Tag_isGray__aXMZ_"};